import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center space-x-4 rounded-sm text-lg font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring  [&_svg]:pointer-events-none [&_svg]:size-[1.375rem] [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        black: "bg-gray-1000 text-white hover:bg-blue-600 disabled:bg-gray-900 disabled:hover:bg-blue-700",
        white: "border border-gray-1000 bg-white text-gray-1000 hover:bg-gray-200 disabled:bg-white disabled:opacity-20",
        gray: "bg-gray-300 disabled:bg-gray-500 disabled:opacity-20",
        icon: "[&_svg]:size-full",
        link: "text-sm text-gray-700 decoration-solid underline-offset-2 hover:underline focus-visible:underline focus-visible:ring-0",
        // destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        // outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        // secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        // ghost: "hover:bg-accent hover:text-accent-foreground",
        // link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-14 w-full px-5",
        fit: "size-fit",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "black",
      size: "default",
    },
  },
);

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});
Button.displayName = "Button";

export { Button, buttonVariants };
